export const WELL_KNOWN_COUNTRIES = {
    NON_EXISTENT_COUNTRY: 0,
    RUSSIA: 643,
    CHINA: 156,
    PAKISTAN: 586,
    TAJIKISTAN: 762,
    KAZAKHSTAN: 398,
    KOREA: 410,
    UKRAINE: 804,
    UZBEKISTAN: 860,
    UK: 826,
    LIECHTENSTEIN: 438,
    USA: 840,
    GERMANY: 276,
    FRANCE: 250,
    GUATEMALA: 320,
    GREECE: 300,
    UNITED_ARAB_EMIRATES: 784,
    CANADA: 124,
    NIGERIA: 566,
    VIRTUAL_COUNTRY_BITCOIN: 1000,
    INDIA: 356,
    VIETNAM: 704,
    PHILIPPINES: 608,
    MEXICO: 484,
    REPUBLIC_OF_SOUTH_AFRICA: 710,
    ISRAEL: 376,
    LEBANON: 422,
    IRELAND: 372,
} as const;

export type WellKnownCountryKey = keyof typeof WELL_KNOWN_COUNTRIES;
export type WellKnownCountryId = (typeof WELL_KNOWN_COUNTRIES)[WellKnownCountryKey];

const {
    NON_EXISTENT_COUNTRY,
    RUSSIA,
    CHINA,
    PAKISTAN,
    TAJIKISTAN,
    KAZAKHSTAN,
    KOREA,
    UKRAINE,
    UZBEKISTAN,
    UK,
    LIECHTENSTEIN,
    USA,
    GERMANY,
    FRANCE,
    GUATEMALA,
    GREECE,
    UNITED_ARAB_EMIRATES,
    CANADA,
    NIGERIA,
    VIRTUAL_COUNTRY_BITCOIN,
    INDIA,
    VIETNAM,
    PHILIPPINES,
    MEXICO,
    REPUBLIC_OF_SOUTH_AFRICA,
    ISRAEL,
    LEBANON,
    IRELAND,
} = WELL_KNOWN_COUNTRIES;

export {
    NON_EXISTENT_COUNTRY,
    RUSSIA,
    CHINA,
    PAKISTAN,
    TAJIKISTAN,
    KAZAKHSTAN,
    KOREA,
    UKRAINE,
    UZBEKISTAN,
    UK,
    LIECHTENSTEIN,
    USA,
    GERMANY,
    FRANCE,
    GUATEMALA,
    GREECE,
    UNITED_ARAB_EMIRATES,
    CANADA,
    NIGERIA,
    VIRTUAL_COUNTRY_BITCOIN,
    INDIA,
    VIETNAM,
    PHILIPPINES,
    MEXICO,
    REPUBLIC_OF_SOUTH_AFRICA,
    ISRAEL,
    LEBANON,
    IRELAND,
};
